export default {
  version: "1.0.4",
  date: "July 2025",
  NotesComponent: () => (
    <ul className="pl-8 pr-8 list-disc list-inside text-left text-sm max-h-[450px] overflow-y-auto space-y-1">
            <li>New "Silk" theme added.</li>
            <li>New time calculator widget.</li>
            <li>Restructured widget backend system. Old toolbelts will no longer work. This will be the last time past toolbelts become obsolete (I promise).</li>
            <li>Rerouted subscription backend to support real transactions. All widgets will remain free until the subscription option is released.</li>
            <li>Upgraded toolbelt creator and editor with new filtering options and improved design.</li>
            <li>Adjusted background pattern opacities. They should now be easier to see with darker themes.</li>
            <li>Fixed UI framing bug for block puzzle.</li>
            <li>Fixed bugs with new account creation.</li>
            <li>Added support and policy links in settings. These currently lead nowhere until the new website is deployed.</li>
    </ul>
  ),
};
